/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Error_Zalo_Oa1Inputs */

const vi_sitesettings_error_zalo_oa1 = /** @type {(inputs: Sitesettings_Error_Zalo_Oa1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zalo OA ID chỉ gồm chữ số.`)
};

/**

* @param {Sitesettings_Error_Zalo_Oa1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_error_zalo_oa1 = /** @type {((inputs?: Sitesettings_Error_Zalo_Oa1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Error_Zalo_Oa1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_error_zalo_oa1(inputs)
});
export { sitesettings_error_zalo_oa1 as "siteSettings_error_zalo_oa" }